<template>
  <pagination v-if="!$feature.tempVansNewNav.value" v-bind="props" />
  <vf-media-gallery-pagination-new v-else v-bind="props" />
</template>

<script lang="ts" setup>
const props = defineProps<{
  activePage: number
  pages: number
}>()

const Pagination = defineAsyncComponent(() => import('#brands/components/vf/media-gallery/Pagination.vue'))
</script>
